import React from "react";
import { motion } from "framer-motion";
import { BusinessReportOutcomeContent } from "./businessReportOutcomeContent";

import RightDrawer from "./rightDrawer";
import { useParams } from "react-router";
import { CurrentPdfProvider } from "@/contexts/setPdfContext";

export const BusinessReportOutcomeDetailsView = () => {
  const { outcomeId } = useParams<{ outcomeId: string }>();
  const [isRightDrawerVisible, setIsRightDrawerVisible] = React.useState(true);
  const [rightDrawerContent, setRightDrawerContent] = React.useState<"pdf" | "settings" | null>("pdf");

  const toggleRightDrawerVisibility = React.useCallback(() => {
    setIsRightDrawerVisible(prev => !prev);
  }, []);

  return (
    <CurrentPdfProvider>
      <div className="flex h-[95vh]">
        <main className="flex flex-grow overflow-hidden">
          <motion.div
            className="flex flex-grow flex-col"
            animate={{ width: isRightDrawerVisible ? "60%" : "100%" }}
            transition={{ duration: 0.3 }}
          >
            <BusinessReportOutcomeContent outcomeId={outcomeId || ""} />
          </motion.div>

          <RightDrawer
            isVisible={isRightDrawerVisible}
            toggleVisibility={toggleRightDrawerVisibility}
            content={rightDrawerContent}
            setContent={setRightDrawerContent}
          />
        </main>
      </div>
    </CurrentPdfProvider>
  );
};
